import React, { FunctionComponent } from 'react';
import DesignText from '@/components/typography/DesignText';
import Col from '@/components/layout/Col';
import Row from '@/components/layout/Row';
import SuggestedAirportCard from '@/components/landingPages/SuggestedAirportCard';
import { IPrismicNearbyAirport } from '@/pageGeneration/services/prismicApi/types';
import styles from './SuggestedAirportsSection.module.scss';

interface IProps {
  airports: IPrismicNearbyAirport[];
}

const SuggestedAirportsSection: FunctionComponent<IProps> = ({ airports }) => (
  <div className={styles.container} data-testid="SuggestedAirportsSectionContainer">
    <Row>
      <Col span={24}>
        <DesignText size="large" color="primary" strong>
          Suggested airports
        </DesignText>
      </Col>
    </Row>
    <Row>
      {airports.map((airport, i) => (
        <Col key={`suggested-airport-${i}`} xs={24} sm={24} md={8} lg={8} xl={8}>
          <SuggestedAirportCard airport={airport.airport} />
        </Col>
      ))}
    </Row>
  </div>
);

export default SuggestedAirportsSection;
